import commonService from './commonService'
import utils from './utils'

const getAll = async (signal = null, axios = null) => {
  const url = utils.url + '/provinces'
  return await commonService.load(url, signal, [], axios)
}

const get = async (id) => {
  const url = `${utils.url}/provinces/${id}`
  return await commonService.load(url)
}

export default { getAll, get }
